import { ApiDynamicExportRun } from '@Model';
import { type Column, Badge } from '@synqo/frontend-component-library';
import {
    getDynamicExportCategoryLabel,
    getDynamicExportKeyLabel,
    getStateLabelAndVariant,
} from '@Constants/dynamicExportConstants';
import { ExportRunResultPreview, FileDownloadCell } from '@Components/index';
import { hasExportRunResult } from '@utils/exportRunResult';

/**
 * What the run produced: the file when there is one, otherwise what the run has to say about how it
 * turned out — a failed run's first reason, with the rest in the detail panel the row opens.
 *
 * @ai-generated 2026-08-26T12:58:28+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
 */
const resultColumn: Column<ApiDynamicExportRun> = {
    name: 'result_file_id',
    label: 'Ergebnis',
    renderCell: ({ rowData }) => {
        const id = rowData.result_file_id;
        if (id) {
            return <FileDownloadCell fileId={id} />;
        }
        return hasExportRunResult(rowData) ? <ExportRunResultPreview run={rowData} /> : '-';
    },
};

export const exportColumns: Column<ApiDynamicExportRun>[] = [
    {
        name: 'state',
        label: 'Status',
        renderCell: ({ rowData }) => {
            const { label, variant } = getStateLabelAndVariant(rowData.state);
            return <Badge variant={variant}>{label}</Badge>;
        },
    },
    { name: 'number', label: 'Nr.' },
    {
        name: 'created_at',
        label: 'Datum',
        type: 'datetime',
    },
    {
        name: 'created_by',
        label: 'Erstellt von',
    },
    resultColumn,
];

export const exportRunColumns: Column<ApiDynamicExportRun>[] = [
    {
        name: 'category',
        label: 'Kategorie',
        renderCell: ({ cellData }) => getDynamicExportCategoryLabel(cellData as string),
    },
    {
        name: 'key',
        label: 'Key',
        renderCell: ({ cellData }) => getDynamicExportKeyLabel(cellData as string),
    },
    {
        name: 'state',
        label: 'Status',
        renderCell: ({ rowData }) => {
            const { label, variant } = getStateLabelAndVariant(rowData.state);
            return <Badge variant={variant}>{label}</Badge>;
        },
    },
    { name: 'number', label: 'Nr.' },
    {
        name: 'created_at',
        label: 'Datum',
        type: 'datetime',
    },
    {
        name: 'created_by',
        label: 'Erstellt von',
    },
    resultColumn,
];
